import { computed } from 'mobx';
import { PartialDeep } from 'type-fest';

import { translate } from 'services/i18nService';
import { AbstractTheme, CampaignFlagsMap, ControlledFeaturesMap, Theme } from 'themes/themes.types';
import { getCampaignWithFlag } from 'themes/utils';
import { MINUTE_AS_MILLISECONDS } from 'enum/timeFormat';

import styles from './HappyHourTheme.css';


export default class HappyHourTheme extends AbstractTheme {
  static CFS: ControlledFeaturesMap = {};
  static CAMPAIGN_FLAGS: CampaignFlagsMap = {
    ON_CAM_ANIMATION: 'HAPPY_HOUR_ON_CAM_ANIMATION',
    HEADER_CTA: 'HAPPY_HOUR_HEADER_CTA',
    MOBILE_OVERLAY: 'HAPPY_HOUR_MOBILE_OVERLAY',
    INFO_STRIP: 'HAPPY_HOUR_INFO_STRIP',
    BUY_TOKENS_MODAL: 'HAPPY_HOUR_BUY_TOKENS_MODAL',
  };

  @computed get theme(): PartialDeep<Theme> {
    const onCamAnimationCampaign = getCampaignWithFlag(HappyHourTheme.CAMPAIGN_FLAGS.ON_CAM_ANIMATION);
    const onCamAnimation = onCamAnimationCampaign ? {
      onCamAnimation: {
        cookieNamePrefix: onCamAnimationCampaign.activeCampaignName,
        animBackgroundClass: styles.animBackground,
        staticBackgroundClass: styles.staticBackground,
        line1Text: translate('campaigns.get.bonus.tokens',
          { 0: onCamAnimationCampaign.campaignDetails.bonusTokenPercent }
        ),
      } as Theme['onCamAnimation'],
    } : {};

    const headerCTACampaign = getCampaignWithFlag(HappyHourTheme.CAMPAIGN_FLAGS.HEADER_CTA);
    const headerCTA = headerCTACampaign ? {
      headerCTA: {
        cookieNamePrefix: headerCTACampaign.activeCampaignName,
        wrapperClass: styles.headerCTAWrapper,
        title: translate('gold.gold.happyHour.tokenOverlay.title'),
      } as Theme['headerCTA'],
    } : {};

    const mobileOverlayCampaign = getCampaignWithFlag(HappyHourTheme.CAMPAIGN_FLAGS.MOBILE_OVERLAY);
    const mobileOverlay = mobileOverlayCampaign ? {
      mobileOverlay: {
        cookieNamePrefix: mobileOverlayCampaign.activeCampaignName,
        delay: 5 * MINUTE_AS_MILLISECONDS,
        title: translate('gold.gold.happyHour.tokenOverlay.title'),
        text: translate('gold.gold.happyHour.bannerBody.copy',
          { 0: mobileOverlayCampaign.campaignDetails.bonusTokenPercent }
        ),
        bodyClass: styles.mobileOverlayBody,
      } as Theme['mobileOverlay'],
    } : {};

    const infoStripCampaign = getCampaignWithFlag(HappyHourTheme.CAMPAIGN_FLAGS.INFO_STRIP);
    const infoStrip = infoStripCampaign ? {
      infoStrip: {
        campaignSecondsLeft: infoStripCampaign.campaignDetails.timeLeft,
        wrapperClass: styles.infoStripWrapperClass,
        title: translate('gold.gold.happyHour.tokenOverlay.title'),
        text: translate('gold.gold.happyHour.bannerBody.copy',
          { 0: infoStripCampaign.campaignDetails.bonusTokenPercent }
        ),
        useTimer: true,
      } as Theme['infoStrip'],
    } : {};

    const buyTokensModalCampaign = getCampaignWithFlag(HappyHourTheme.CAMPAIGN_FLAGS.BUY_TOKENS_MODAL);
    const buyTokensModal = buyTokensModalCampaign ? {
      buyTokensModal: {
        cookieNamePrefix: buyTokensModalCampaign.activeCampaignName,
        headerClass: styles.buyTokensModalHeader,
        title: translate('gold.gold.happyHour.tokenOverlay.title'),
        text: translate('gold.gold.happyHour.tokenOverlay.copy',
          { 0: buyTokensModalCampaign.campaignDetails.bonusTokenPercent }
        ),
      } as Theme['buyTokensModal'],
    } : {};

    return {
      ...onCamAnimation,
      ...headerCTA,
      ...mobileOverlay,
      ...infoStrip,
      ...buyTokensModal,
    };
  }
}
